module.exports = __webpack_public_path__ + "static/img/info-2.fbf18e46.png";